module.exports = __webpack_public_path__ + "static/media/wom-mas-400-gigas.9008b4f1.svg";